module.exports = __webpack_public_path__ + "img/member_apple.2c5973cc.png";